import React from 'react';

export default function ShoppingBagIcon({ className = '', title }) {
  return (
 <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M9 0C11.07 0 12.75 1.68 12.75 3.75V9.75H11.25V3.75C11.25 2.5125 10.2375 1.5 9 1.5C7.7625 1.5 6.75 2.5125 6.75 3.75V9.75H5.25V3.75C5.25 1.68 6.93 0 9 0Z"
        fill="currentColor"
      />
      <path
        d="M3.8252 6.75H3.34473L1.74316 16.5H15.5068L13.9053 6.75H13.4248V5.25H15.1602L17.25 18H0L2.08984 5.25H3.8252V6.75ZM9.36328 6.75H7.88672V5.25H9.36328V6.75Z"
        fill="currentColor"
      />
    </svg>

  );
}

